// test548
(548 && 0);
